<style scoped>
    @import url("../../styles/smartControl/geralSmartControl.scss");
</style>

<template>
    <div class="box_geralSC">

        <!-- TITULO GERAL -->
        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-poll</v-icon>
            <span class="ml-2">Histórico de leitura</span>
        </div>

        <!-- MSG ERRO: SISTEMA NAO SELECIONADO NA PAG INICIAL -->
        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- LOADING -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- GERAL -->
        <div class="painelGeral" v-if="!flagMsgSistema && !flagLoading">

            <!-- EXIBIR SELEÇÃO -->
            <div class="liGraf" v-if="flagGrafOpen">

                <GrafHist v-for="(graf,indexG) in liGraf" :key="graf.idGraf"
                :range_init="graf['range_init']"
                :range_end="graf['range_end']"
                :device_id="graf['device_id']"
                :target_key="graf['sub_marcador']"
                :main_tit="graf['titulo']"
                
                :indexGraf="indexG"
                :fatherCounter="grafKey"

                @closeGraf="closeGrafByIndex($event)"
                />

            </div>

            <!-- BTN OPEN CARD SELECIONAR -->

            <!-- SELECIONAR -->
            <SelectExib
            :agent_unit="agent_unit"
            :cl="$store.state.emailCliente"
            :sys_agend="$store.state.sistemaSC"
            :flagStrWrap="flagStrWrap"
            :liSeI="liDevicesExib"
            @formFromChild="callRange($event)"
            />

        </div>
    </div>
</template>

<script>
import { convToUtc } from "./auxSC/timeConv.js";

import axios from 'axios'

import SelectExib from './subHist/SelectExib'
import GrafHist from './subHist/GrafHist'

export default {

    components:{SelectExib,GrafHist},

    data() {
        return {
            // estrutural
            flagLoading:true, // inicia em loading...
            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
            flagGrafOpen:false,
            grafKey:0, // refresh graf a cada nova busca
            flagStrWrap:'no-wrap', // destinado a quebrar ou nao linha no child de seleção

            // agent unit
            agent_unit:null,
            liDevicesExib:[],
            localForm:{},

            // lista de graficos
            liGraf:[], // lista de dicionarios
        }
    },

    methods:{

        closeGrafByIndex(localGrafIndex) {
            this.liGraf.splice(localGrafIndex, 1)
            //this.grafKey++ // refresh graf a cada nova busca
        },

        callRange(form) {
            //console.log('[HistSCV2][callRange] form from child: ',form)

            const graf = {
                ...form,
                idGraf: ++this.grafKey // <--- add nova key com index da ordem de entrada de criação de um gráfico
            }

            this.liGraf.push(graf) // v2
            //this.localForm = form // v1
            
            this.grafKey++ // refresh graf a cada nova busca
            this.flagGrafOpen = true
        },

        // FORMATAR PARA DD/MM/YYYY
        formatarData(data) {
            const dia = String(data.getDate()).padStart(2, '0')
            const mes = String(data.getMonth() + 1).padStart(2, '0')
            const ano = data.getFullYear()

            return `${dia}/${mes}/${ano}`
        },

        // FORMATAR PARA HH:mm
        formatarHora(data) {
            const hora = String(data.getHours()).padStart(2, '0')
            const minuto = String(data.getMinutes()).padStart(2, '0')

            return `${hora}:${minuto}`
        },
        
        preInit() {

            // tam page
            const largura = window.innerWidth
            if (largura > 350) { this.flagStrWrap = 'no-wrap' }
            else { this.flagStrWrap = 'wrap' }
            
            const sistema = this.$store.state.sistemaSC // v2 14/08/2025
            const cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025
            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }
            let params = { 'cliente':cl, 'sistema':sistema }
            let self = this
            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result)

                const el = res.data.result // agent_unit
                self.agent_unit = el
                const liSensores = el['sensores']
                const liIndices = el['indices']

                let c=0
                while ( c < liSensores.length ) {
                    let w = 0
                    while ( w < liSensores[c]['params'].length) {
                        self.liDevicesExib.push({
                            'device_id':liSensores[c]['device'], // device_id
                            'titulo':liSensores[c]['params'][w]['titulo'],
                            'sub_marcador':liSensores[c]['params'][w]['sub_marcador']
                        })
                        w++
                    }
                    c++
                }

                c=0
                while ( c < liIndices.length ) {
                    let j = 0
                    while ( j < liIndices[c]['params'].length) {
                        self.liDevicesExib.push({
                            'device_id':liIndices[c]['device'], // device_id
                            'titulo':liIndices[c]['params'][j]['titulo'],
                            'sub_marcador':liIndices[c]['params'][j]['sub_marcador']
                        })
                        j++
                    }
                    c++
                }
                self.flagLoading = false // abrir childs

                // AGORA
                const agora = new Date()
                // 48 HORAS ATRÁS
                const inicio = new Date(agora.getTime() - (48 * 60 * 60 * 1000))

                const dataInit = self.formatarData(inicio)
                const horaInit = self.formatarHora(inicio)
                const dataEnd = self.formatarData(agora)
                const horaEnd = self.formatarHora(agora)
                const tzName = self.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"
                // CONVERTER HORÁRIO LOCAL -> UTC
                const resUTCInit = convToUtc(
                    dataInit,
                    horaInit,
                    tzName
                )

                const resUTCEnd = convToUtc(
                    dataEnd,
                    horaEnd,
                    tzName
                )
                const form = {
                    "range_init":`${resUTCInit.dataUtcStr}-${resUTCInit.hhmmUtc}`,
                    "range_end":`${resUTCEnd.dataUtcStr}-${resUTCEnd.hhmmUtc}`,
                    "device_id":self.liDevicesExib[0].device_id,
                    "titulo":self.liDevicesExib[0].titulo,
                    "sub_marcador":self.liDevicesExib[0].sub_marcador // target_key
                }
                self.callRange(form)
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false
            this.preInit()
        }
        
    }
}
</script>